import { render, staticRenderFns } from "./user-points-detail.vue?vue&type=template&id=1e24b3a6&"
import script from "./user-points-detail.vue?vue&type=script&lang=js&"
export * from "./user-points-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports